import { Routes } from '@angular/router';
import { AppLayout } from './layout/component/app.layout';
import { Dashboard } from './pages/dashboard/dashboard';
import { Landing } from './pages/landing/landing';
import { Notfound } from './pages/notfound/notfound';
import { SeasonDashboardComponent } from './pages/league/seasonDashboard.component';
import { PlayerDetailsComponent } from './pages/player/playerDetails.component';


export const appRoutes: Routes = [
    {
        path: '',
        component: AppLayout,
        children: [
            { path: '', component: Dashboard},
            { path: 'season', component: SeasonDashboardComponent },
            { path: 'season/:season', component: SeasonDashboardComponent },
            // Legacy deep links from before the unified season dashboard.
            { path: 'league/:season/:version', redirectTo: 'season/:season' },
            { path: 'circuits', loadComponent: () => import('./pages/circuits/circuitList.component').then((m) => m.CircuitListComponent) },
            { path: 'circuits/:id', loadComponent: () => import('./pages/circuits/circuitDetail.component').then((m) => m.CircuitDetailComponent) },
            { path: 'comparison', loadComponent: () => import('./pages/comparison/comparison.component').then((m) => m.ComparisonComponent) },
            { path: 'teams', loadComponent: () => import('./pages/teams/teamList.component').then((m) => m.TeamListComponent) },
            { path: 'teams/:season', loadComponent: () => import('./pages/teams/teamList.component').then((m) => m.TeamListComponent) },
            { path: 'playerDetails/:id', component: PlayerDetailsComponent},
            //{ path: '', component: Dashboard },
            { path: 'pages', loadChildren: () => import('./pages/pages.routes') }
        ]
    },
    { path: 'landing', component: Landing },
    { path: 'notfound', component: Notfound },
    { path: 'auth', loadChildren: () => import('./pages/auth/auth.routes') },
    { path: '**', redirectTo: '/notfound' }
];